import React, { FC } from 'react'

import { styled } from '@linaria/react'

import { WithDataName } from 'common/types'
import { Typography } from 'components/designSystem/Typography/Typography'

export const ProfileText: FC<
  {
    text: string
  } & WithDataName
> = ({ text, ...rest }) => {
  return (
    <Text fontSize={24} fontWeight={500} data-name={rest['data-name']} tag="p">
      {text}
    </Text>
  )
}

const Text = styled(Typography)`
  word-wrap: break-word;
  color: var(--foreground-soft);
`
